export enum LoadingKeys {
  Hobbies = 'Hobbies',
  Languages = 'Languages',
  Countries = 'Countries',
  Regions = 'Regions',
  CoachesLite = 'CoachesLite',
  AllExperiences = 'AllExperiences',
  WantedExperiences = 'AllExperiences',

  GetExpDetails = 'AllExperiences',
  AddOrEditExperience = 'AddOrEditExperience',
  ExperienceLogs = 'ExperienceLogs',
  ExperiencesLogs = 'ExperiencesLogs',
  GetAllExperiencesLite = 'GetAllExperiencesLite',
  AddExpToFav = 'AddExpToFav',
  AddExpToVibe = 'AddExpToVibe',
  ChangeExpStatus = 'ChangeExpStatus',
  Login = 'login',
  ExperienceSessions = 'ExperienceSessions',
  SessionPaidChange = 'SessionPaidChange',
  CancelSession = 'CancelSession',
  SessionsLogs = 'SessionsLogs',
  SessionLogs = 'SessionLogs',
  DefaultSession = 'DefaultSession',
  GetSessionDetailsById = 'GetSessionDetailsById',
  RemoveSessionLearner = 'RemoveSessionLearner',
  GetSessionLearners = 'GetSessionLearners',
  GetSessionLearnersLogs = 'GetSessionLearnersLogs',
  PutAttendees = 'PutAttendees',
  ResetSession = 'ResetSession',

  CreateOrEditSession = 'CreateOrEditSession',
  ReviewsList = 'ReviewsList',
  ChangeReviewStatus = 'ChangeReviewStatus',
  GetAllLearners = 'GetAllLearners',
  GetAllLearnersLite = 'GetAllLearnersLite',
  AddLearnerToSession = 'AddLearnerToSession',

  GetLearnerById = 'GetLearnerById',
  createOrUpdateLearner = 'createOrUpdateLearner',
  LearnerLogs = 'LearnerLogs',
  GetAllDiscountCodes = 'GetAllDiscount',
  GetDiscountDetails = 'GetDiscountDetails',
  CreateOrUpdateDiscountCode = 'CreateOrUpdateDiscountCode',
  GetDiscountLogs = 'GetDiscountLogs',
  GetAllDiscountCodesCampings = 'GetAllDiscountCodesCampings',
  ChangeDiscountCodesStatus = 'ChangeDiscountCodesStatus',
  GetNotificationsList = 'GetNotificationsList',
  ChangeNotificationStatus = 'ChangeNotificationStatus',
  CreateNotification = 'CreateNotification',
  CheeringList = 'CheeringList',
  BookingList = 'BookingList',
  paymentErrorList = 'paymentErrorList',
  RefundLearner = 'RefundLearner',
  RefundPayment = 'RefundPayment',
  BookingLogs = 'BookingLogs',
  GetAllGiftCards = 'GetAllGiftCards',
  ChangeGiftCardStatus = 'ChangeGiftCardStatus',
  GetGiftCardById = 'GetGiftCardById',
  createOrUpdateGiftCard = 'createOrUpdateGiftCard',
  GiftBookingList = 'giftBookingList',
  B2BGiftCardList = 'B2BGiftBookingList',
  GetClaimCodes = 'GetClaimCodes',
  GetAllGiftCardsLite = 'GetAllGiftCardsLite',
  GetB2BGiftCardById = 'GetB2BGiftCardById',
  CreateOrUpdateB2BGiftCard = 'CreateOrUpdateB2BGiftCard',
  GetB2BTransactionList = 'GetB2BTransactionList',
  DashboardReviewsList = 'DashboardReviewsList',
  GetAllBalance = 'GetAllBalance',
  GetBannersList = 'GetBannersList',
  ChangeBannerStatus = 'ChangeBannerStatus',
  GetBannerDetailsById = 'GetLearnerBannerById',
  CreateOrEditLearnerBanner = 'CreateOrEditLearnerBanner',
  CreateOrEditCoachBanner = 'CreateOrEditCoachBanner',

  SortBanners = 'SortBanners',
  CreateGiftBooking = 'CreateGiftBooking',
  CoachLogs = 'CoachLogs',
  GetCoachById = 'GetCoachById',
  ChangeCoachStatus = 'ChangeCoachStatus',
  createOrUpdateCoach = 'createOrUpdateCoach',
  GetCoachesList = 'GetCoachesList',
  AccountManager = 'accountManager',
  ChangeAccountManagerStatus = 'ChangeAccountManagerStatus',

  GetAllCollections = 'GetAllCollections',
  GetCollectionById = 'GetCollectionById',
  CreateOrUpdateCollection = 'CreateOrUpdateCollection',
  SortCollections = 'SortCollections',
  changeCollectionStatus = 'changeCollectionStatus',
  getAutocomplete = 'getAutocomplete',
  getAccountManagerById = 'getAccountManagerById',
  getAccountManagerCoaches = 'getAccountManagerCoaches',
  removeAccountManagerCoach = 'removeAccountManagerCoach',
  getAvailableCoachesList = 'getAvailableCoachesList',
  createOrUpdateAccountManager = 'createOrUpdateAccountManager',
  CoachBalance = 'CoachBalance',
  CoachBalanceLogs = 'CoachBalanceLogs',
  nationalities = 'nationalities',
  paymentCategories = 'paymentCategories',

  approvals = 'Approvals',
  getApprovalList = 'getApprovalList',

  GetGigsList = 'GetGigsList',
  changeGigStatus = 'changeGigStatus',
  PriceTypes = 'PriceTypes',
  createOrUpdateGig = 'createOrUpdateGig',
  getNationalities = 'getNationalities',
  getGigById = 'getGigById',
  GetGigsApplications = 'GetGigsApplications',
  ChangeApplicationStatus = 'ChangeApplicationStatus',
  getAllGigsLite = 'getAllGigsLite',
  getGigSegmentedCoaches = 'getGigSegmentedCoaches',
  sendGigNotification = 'sendGigNotification',
  getNotificationsHistoryList = 'getNotificationsHistory',
  searchOnCoachByNotificationId = 'searchOnCoachByNotificationId',
  GetApprovalsList = 'GetApprovalsList',
  ChangeApprovalStatus = 'ChangeApprovalStatus',
  getApprovalData = 'getApprovalData',
  refetchApprovalData = 'refetchApprovalData',
  editApproval = 'editApproval',
  FetchCoachIosVersion = 'fetchCoachIosVersion',
  FetchCoachAndroidVersion = 'fetchCoachAndroidVersion',
  FetchLearnerIosVersion = 'fetchLearnerIosVersion',
  FetchLearnerAndroidVersion = 'fetchLearnerAndroidVersion',
  SaveCoachIosVersion = 'saveCoachIosVersion',
  SaveCoachAndroidVersion = 'saveCoachAndroidVersion',
  SaveLearnerIosVersion = 'saveLearnerIosVersion',
  SaveLearnerAndroidVersion = 'saveLearnerAndroidVersion',
}
